// extracted by mini-css-extract-plugin
module.exports = {"dialog":"InviteMemberDialog_dialog__NTmQd","teamPositioner":"InviteMemberDialog_teamPositioner__1fY_p","selectBase":"InviteMemberDialog_selectBase__HW_ET"};